import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HttpManagement from '../API/interceptor';

import Header from '../shared/header';
import { RightSidePaneProvider } from '../contexts/rightSidePane/rightSidePane';

export default function RootLayout() {
  const location = useLocation();

  return (
    <>
      <HttpManagement>
        <ToastContainer autoClose={5000} hideProgressBar={true} />
        <RightSidePaneProvider>
          <div>
            {location.pathname !== '/login' ? <Header /> : null}
            <main>
              <Outlet />
            </main>
          </div>
        </RightSidePaneProvider>
      </HttpManagement>
    </>
  );
}
